import type { RendererBridge } from '@/modules/rendererBridge';

/**
 * Lets the undo stack's ports update the renderer and the editor only while `live()`: the undo or redo making
 * the update started in the scene still open. One still running when another scene opened finishes its writes
 * for its own scene, but its messages and editor updates would land in the other scene, so they are dropped.
 */
export function sceneGate(live: () => boolean) {
  return {
    /** The renderer, sent to only while live. */
    bridge: (bridge: Pick<RendererBridge, 'send'>): Pick<RendererBridge, 'send'> => ({
      send: message => {
        if (live()) bridge.send(message);
      },
    }),
    /** An editor update, run only while live. */
    update: <A extends unknown[]>(apply: (...args: A) => unknown) => async (...args: A): Promise<void> => {
      if (live()) await apply(...args);
    },
  };
}
